'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _reactPerfectScrollbar = require('react-perfect-scrollbar');

var _reactPerfectScrollbar2 = _interopRequireDefault(_reactPerfectScrollbar);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _path = require('ramda/src/path');

var _path2 = _interopRequireDefault(_path);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _onlinepbxStatus = require('./onlinepbx-status');

var _onlinepbxStatus2 = _interopRequireDefault(_onlinepbxStatus);

var _onlinepbxWarning = require('./onlinepbx-warning');

var _onlinepbxWarning2 = _interopRequireDefault(_onlinepbxWarning);

var _onlinepbxQuestion = require('./onlinepbx-question');

var _onlinepbxQuestion2 = _interopRequireDefault(_onlinepbxQuestion);

var _throttle = require('lodash/throttle');

var _throttle2 = _interopRequireDefault(_throttle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var ArrowIcon = function () {
  function ArrowIcon(props) {
    return _react2['default'].createElement(
      'svg',
      props,
      _react2['default'].createElement('path', {
        d: 'M15 7.5l-5 5-5-5',
        stroke: '#A8A4B9',
        strokeLinecap: 'round',
        strokeLinejoin: 'round'
      })
    );
  }

  return ArrowIcon;
}();

ArrowIcon.defaultProps = {
  width: '20',
  height: '20',
  viewBox: '0 0 20 20',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
};

var CrossIcon = function () {
  function CrossIcon(props) {
    return _react2['default'].createElement(
      'svg',
      props,
      _react2['default'].createElement('path', {
        d: 'M15 5L5 15M5 5l10 10',
        stroke: '#A8A4B9',
        strokeLinecap: 'round',
        strokeLinejoin: 'round'
      })
    );
  }

  return CrossIcon;
}();

CrossIcon.defaultProps = {
  width: '20',
  height: '20',
  viewBox: '0 0 20 20',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
};


var defaultModalHeight = 200;
var defaultPanelHeight = 28;
var metaKeysArr = ['Enter', 'NumpadEnter', 'Tab', 'Escape'];

var nameResolver = function nameResolver(fieldName, fieldId, options, optionKey) {
  if (fieldName && fieldId && Array.isArray(fieldName) && fieldName[0] === fieldId) return (0, _path2['default'])([optionKey].concat(_toConsumableArray(fieldName)), options) || '(Без названия)';
  if (fieldName && fieldId && !Array.isArray(fieldName) && fieldName === fieldId) return (0, _path2['default'])([optionKey].concat(_toConsumableArray(fieldName)), options) || '(Без названия)';
  if (fieldName) return (0, _path2['default'])([optionKey].concat(_toConsumableArray(fieldName)), options) || '(Без названия)';
  return options[optionKey] || '';
};

/** Props:
 *       options,
 *       label,
 *       optionId,
 *       dark,
 *       disabled,
 *       questionText,
 *       onChangeSearch,
 *       defaultText,
 *       placeholder,
 *       placeholderSelect,
 *       warningText,
 *       fieldColor,
 *       className,
 *       isDisabledSearch,
 *       onKeyDown,
 *       onKeyDownClose
 *       theFirstEmptyElement,
 *       emptyFilterText,
 *       hasSortById,
 *       onClick,
 *       isEmpty,
 *       fieldId,
 *       cbSortKeys,
 *       optimizeHeightPanel,
 */
var OnlinepbxSelect = (_temp = _class = function (_React$Component) {
  _inherits(OnlinepbxSelect, _React$Component);

  function OnlinepbxSelect(props) {
    _classCallCheck(this, OnlinepbxSelect);

    var _this = _possibleConstructorReturn(this, (OnlinepbxSelect.__proto__ || Object.getPrototypeOf(OnlinepbxSelect)).call(this, props));

    _this.state = {
      isModal: false,
      isInput: false,
      search: '',
      value: '',
      position: null,
      scroll: 0,
      modalHeight: defaultModalHeight
    };
    _this.domNode = document.createElement('div');
    _this.renderModal = _this.renderModal.bind(_this);
    _this.isCursor = true;
    _this.handleUpdate = _this.handleUpdate.bind(_this);
    _this.handleScroll = (0, _throttle2['default'])(_this.handleScroll.bind(_this), 100, {
      leading: true,
      trailing: true
    });
    return _this;
  }

  _createClass(OnlinepbxSelect, [{
    key: 'componentDidMount',
    value: function () {
      function componentDidMount() {
        var _this2 = this;

        this.handleUpdate();
        var containers = document.querySelectorAll('.scrollbar__dark');
        containers.forEach(function (container) {
          return container.addEventListener('scroll', _this2.handleUpdate);
        });
      }

      return componentDidMount;
    }()
  }, {
    key: 'componentWillUnmount',
    value: function () {
      function componentWillUnmount() {
        var _this3 = this;

        var containers = document.querySelectorAll('.scrollbar__dark');
        containers.forEach(function (container) {
          return container.removeEventListener('scroll', _this3.handleUpdate);
        });
        document.body.contains(this.domNode) && document.body.removeChild(this.domNode);
      }

      return componentWillUnmount;
    }()
  }, {
    key: 'handleUpdate',
    value: function () {
      function handleUpdate() {
        this.setState({
          isModal: false,
          isInput: false,
          position: this.select && this.select.getBoundingClientRect(),
          scroll: 0,
          modalHeight: defaultModalHeight
        });
      }

      return handleUpdate;
    }()
  }, {
    key: 'componentDidUpdate',
    value: function () {
      function componentDidUpdate(prevProps, prevState) {
        if (this.state.isModal && !prevState.isModal) {
          document.body.appendChild(this.domNode);
        } else if (!this.state.isModal && prevState.isModal) {
          document.body.removeChild(this.domNode);
        }
      }

      return componentDidUpdate;
    }()
  }, {
    key: 'handleScroll',
    value: function () {
      function handleScroll(event) {
        if (!this.props.optimizeHeightPanel) return;

        this.setState({ scroll: event.scrollTop });
      }

      return handleScroll;
    }()
  }, {
    key: 'render',
    value: function () {
      function render() {
        var _this4 = this,
            _classNames3,
            _classNames4,
            _classNames5,
            _classNames6;

        var _props = this.props,
            _props$options = _props.options,
            options = _props$options === undefined ? {} : _props$options,
            label = _props.label,
            _props$optionId = _props.optionId,
            optionId = _props$optionId === undefined ? '' : _props$optionId,
            dark = _props.dark,
            disabled = _props.disabled,
            questionText = _props.questionText,
            onChangeSearch = _props.onChangeSearch,
            _props$defaultText = _props.defaultText,
            defaultText = _props$defaultText === undefined ? 'По умолчанию' : _props$defaultText,
            _props$placeholder = _props.placeholder,
            placeholder = _props$placeholder === undefined ? '' : _props$placeholder,
            placeholderSelect = _props.placeholderSelect,
            warningText = _props.warningText,
            fieldColor = _props.fieldColor,
            _props$className = _props.className,
            className = _props$className === undefined ? 'onlinepbx__lib__select' : _props$className,
            isDisabledSearch = _props.isDisabledSearch,
            _onKeyDown = _props.onKeyDown,
            onKeyDownClose = _props.onKeyDownClose;

        var fieldName = this.props.fieldName && !Array.isArray(this.props.fieldName) ? [this.props.fieldName] : this.props.fieldName;
        return [_react2['default'].createElement(
          'div',
          {
            key: 'select_wrapper',
            style: { width: '100%' },
            onMouseEnter: function () {
              function onMouseEnter() {
                _this4.isCursor = false;
              }

              return onMouseEnter;
            }(),
            onMouseLeave: function () {
              function onMouseLeave() {
                _this4.isCursor = true;
              }

              return onMouseLeave;
            }(),
            ref: function () {
              function ref(node) {
                if (node && !_this4.select) {
                  _this4.forceUpdate();
                }
                _this4.select = node || _this4.select;
              }

              return ref;
            }(),
            className: (0, _classnames2['default'])(_defineProperty({}, String(className) + '__focus', this.state.isInput))
          },
          _react2['default'].createElement(
            'div',
            {
              className: (0, _classnames2['default'])('' + String(className), _defineProperty({}, String(className) + '__top', this.state.position && this.state.position.y >= document.body.clientHeight / 2.4))
            },
            label && _react2['default'].createElement(
              'div',
              { className: String(className) + '__label__wrapper' },
              _react2['default'].createElement(
                'div',
                { className: String(className) + '__label__head' },
                _react2['default'].createElement(
                  'div',
                  {
                    onClick: function () {
                      function onClick() {
                        _this4.handleUpdate();
                        _this4.setState({
                          isModal: !_this4.state.isModal,
                          isInput: !_this4.state.isInput,
                          search: '',
                          scroll: 0,
                          modalHeight: defaultModalHeight
                        });
                      }

                      return onClick;
                    }(),
                    className: (0, _classnames2['default'])(String(className) + '__label', (_classNames3 = {}, _defineProperty(_classNames3, String(className) + '__label__focus', this.state.isInput), _defineProperty(_classNames3, String(className) + '__label__disabled', disabled), _defineProperty(_classNames3, String(className) + '__label__dark', dark), _classNames3))
                  },
                  label
                )
              )
            ),
            _react2['default'].createElement(
              'div',
              { className: String(className) + '__content' },
              _react2['default'].createElement(
                'div',
                {
                  className: (0, _classnames2['default'])(String(className) + '__wrapper', (_classNames4 = {}, _defineProperty(_classNames4, String(className) + '__wrapper__disabled', disabled), _defineProperty(_classNames4, String(className) + '__wrapper__error', warningText), _defineProperty(_classNames4, String(className) + '__wrapper__focus', this.state.isInput), _classNames4))
                },
                _react2['default'].createElement(
                  'div',
                  { className: String(className) + '__value__container' },
                  this.state.isInput && _react2['default'].createElement(
                    'div',
                    {
                      onClick: function () {
                        function onClick() {
                          if (isDisabledSearch) {
                            _this4.setState({
                              isModal: !_this4.state.isModal,
                              isInput: !_this4.state.isModal,
                              search: '',
                              scroll: 0,
                              modalHeight: defaultModalHeight
                            });
                          }
                        }

                        return onClick;
                      }(),
                      className: String(className) + '__value__block' },
                    _react2['default'].createElement('input', {
                      placeholder: placeholder,
                      className: (0, _classnames2['default'])(String(className) + '__value', (_classNames5 = {}, _defineProperty(_classNames5, String(className) + '__value__label', !label), _defineProperty(_classNames5, String(className) + '__value__question', questionText), _classNames5)),
                      ref: function () {
                        function ref(node) {
                          if (node && !_this4.input) {
                            _this4.forceUpdate();
                          }
                          _this4.input = node || _this4.input;
                        }

                        return ref;
                      }(),
                      autoFocus: !isDisabledSearch,
                      onKeyDown: function () {
                        function onKeyDown(evt) {
                          if (onKeyDownClose && metaKeysArr.includes(evt.key)) {
                            _this4.setState({
                              isInput: false,
                              isModal: false,
                              search: '',
                              scroll: 0,
                              modalHeight: defaultModalHeight
                            });
                          }
                          return typeof _onKeyDown === 'function' && _onKeyDown(evt, optionId);
                        }

                        return onKeyDown;
                      }(),
                      onChange: function () {
                        function onChange(evt) {
                          _this4.scrollModal.scrollTop = 0;
                          typeof onChangeSearch === 'function' && onChangeSearch(evt);
                          _this4.setState({
                            search: evt.target.value || '',
                            scroll: 0,
                            modalHeight: defaultModalHeight
                          });
                        }

                        return onChange;
                      }(),
                      onBlur: function () {
                        function onBlur() {
                          return _this4.isCursor && _this4.setState({
                            isInput: false,
                            isModal: false,
                            search: '',
                            scroll: 0,
                            modalHeight: defaultModalHeight
                          });
                        }

                        return onBlur;
                      }(),
                      disabled: this.props.isDisabledSearch
                    })
                  ) || _react2['default'].createElement(
                    'div',
                    { className: String(className) + '__value__block' },
                    _react2['default'].createElement(
                      'button',
                      {
                        title: fieldName && (0, _path2['default'])([optionId].concat(_toConsumableArray(fieldName)), options) || optionId || defaultText,
                        disabled: disabled,
                        onClick: function () {
                          function onClick() {
                            _this4.handleUpdate();
                            _this4.setState({
                              isModal: !_this4.state.isModal,
                              isInput: true,
                              search: '',
                              scroll: 0,
                              modalHeight: defaultModalHeight
                            });
                          }

                          return onClick;
                        }(),
                        className: (0, _classnames2['default'])(String(className) + '__value', (_classNames6 = {}, _defineProperty(_classNames6, String(className) + '__value__label', !label), _defineProperty(_classNames6, String(className) + '__value__warning', warningText), _defineProperty(_classNames6, String(className) + '__value__question', questionText), _defineProperty(_classNames6, String(className) + '__value__disabled', disabled), _defineProperty(_classNames6, String(className) + '__value__placeholder', placeholderSelect && !optionId), _classNames6))
                      },
                      fieldColor && (0, _onlinepbxStatus2['default'])({
                        status: {
                          isEllipse: true,
                          text: true,
                          name: (0, _path2['default'])([optionId, fieldColor], options)
                        }
                      }),
                      _react2['default'].createElement(
                        'div',
                        { className: String(className) + '__value__text' },
                        fieldName && (0, _path2['default'])([optionId].concat(_toConsumableArray(fieldName)), options) || optionId || placeholderSelect || defaultText
                      )
                    )
                  ),
                  warningText && _react2['default'].createElement(_onlinepbxWarning2['default'], {
                    onMouseEnter: function () {
                      function onMouseEnter() {
                        _this4.isCursor = true;
                      }

                      return onMouseEnter;
                    }(),
                    onMouseLeave: function () {
                      function onMouseLeave() {
                        _this4.isCursor = false;
                      }

                      return onMouseLeave;
                    }(),
                    text: warningText
                  }),
                  questionText && _react2['default'].createElement(_onlinepbxQuestion2['default'], {
                    onMouseEnter: function () {
                      function onMouseEnter() {
                        _this4.isCursor = true;
                      }

                      return onMouseEnter;
                    }(),
                    onMouseLeave: function () {
                      function onMouseLeave() {
                        _this4.isCursor = false;
                      }

                      return onMouseLeave;
                    }(),
                    text: questionText
                  }),
                  !disabled && this.state.search && _react2['default'].createElement(CrossIcon, {
                    className: 'onlinepbx__lib__cross',
                    onClick: function () {
                      function onClick() {
                        _this4.input.value = '';
                        _this4.setState({ search: '', scroll: 0, modalHeight: defaultModalHeight });
                        _this4.input.focus();
                      }

                      return onClick;
                    }()
                  }) || !disabled && _react2['default'].createElement(ArrowIcon, {
                    onClick: function () {
                      function onClick() {
                        _this4.handleUpdate();
                        _this4.setState({
                          isModal: !_this4.state.isModal,
                          isInput: !_this4.state.isModal,
                          search: '',
                          scroll: 0,
                          modalHeight: defaultModalHeight
                        });
                      }

                      return onClick;
                    }(),
                    className: (0, _classnames2['default'])('onlinepbx__lib__arrows', {
                      onlinepbx__lib__arrows__active: this.state.isModal
                    })
                  }) || ''
                )
              )
            )
          )
        ), this.state.isModal && _reactDom2['default'].createPortal(this.renderModal(), this.domNode)];
      }

      return render;
    }()
  }, {
    key: 'renderModal',
    value: function () {
      function renderModal() {
        var _this5 = this,
            _classNames7;

        var _props2 = this.props,
            fieldColor = _props2.fieldColor,
            _props2$className = _props2.className,
            className = _props2$className === undefined ? 'onlinepbx__lib__select' : _props2$className,
            theFirstEmptyElement = _props2.theFirstEmptyElement,
            _props2$emptyFilterTe = _props2.emptyFilterText,
            emptyFilterText = _props2$emptyFilterTe === undefined ? 'Не найдено' : _props2$emptyFilterTe,
            hasSortById = _props2.hasSortById,
            options = _props2.options,
            optionId = _props2.optionId,
            _onClick = _props2.onClick,
            _props2$isEmpty = _props2.isEmpty,
            isEmpty = _props2$isEmpty === undefined ? true : _props2$isEmpty,
            _props2$fieldId = _props2.fieldId,
            fieldId = _props2$fieldId === undefined ? '' : _props2$fieldId,
            cbSortKeys = _props2.cbSortKeys,
            optimizeHeightPanel = _props2.optimizeHeightPanel,
            isDisabledSearch = _props2.isDisabledSearch;

        var height = className === 'onlinepbx__lib__select' ? 5 : 0;
        var fieldName = this.props.fieldName && !Array.isArray(this.props.fieldName) ? [this.props.fieldName] : this.props.fieldName;

        var optionsKeys = Object.keys(options);
        if (hasSortById) {
          optionsKeys.sort(function (optionsKey1, optionsKey2) {
            return optionsKey1 - optionsKey2;
          });
        }

        if (typeof cbSortKeys === 'function') {
          optionsKeys.sort(cbSortKeys);
        }

        var optionsKeysFiltered = optionsKeys.filter(function (optionId) {
          return (fieldName && (0, _path2['default'])([optionId].concat(_toConsumableArray(fieldName)), options) + '' || options[optionId] + '' || optionId + '' || '').toLowerCase().includes((_this5.state.search || '').toLowerCase());
        });

        var noVisibleBeforeCountElements = 0;
        var noVisibleBeforeHeight = 0;
        var visibleCountElements = optionsKeysFiltered.length;
        var noVisibleAfterHeight = 0;
        if (optimizeHeightPanel) {
          visibleCountElements = Math.ceil(this.state.modalHeight * 2 / defaultPanelHeight);
          if (optionsKeysFiltered.length >= visibleCountElements) {
            noVisibleBeforeCountElements = Math.floor(Math.max(0, this.state.scroll - this.state.modalHeight * 0.5) / defaultPanelHeight);
            noVisibleBeforeHeight = noVisibleBeforeCountElements * defaultPanelHeight;
            noVisibleAfterHeight = Math.max(0, optionsKeysFiltered.length - (noVisibleBeforeCountElements + visibleCountElements)) * defaultPanelHeight;
          }
        }
        return _react2['default'].createElement(
          'div',
          _extends({}, isDisabledSearch ? {
            ref: function () {
              function ref(node) {
                return setTimeout(function () {
                  return node && node.focus();
                }, 0);
              }

              return ref;
            }(),
            tabIndex: 0,
            onBlur: function () {
              function onBlur() {
                return _this5.isCursor && _this5.setState({
                  isInput: false,
                  isModal: false,
                  search: '',
                  scroll: 0,
                  modalHeight: defaultModalHeight
                });
              }

              return onBlur;
            }()
          } : {}, {
            style: {
              width: this.select && this.select.offsetWidth,
              top: this.state.position && this.state.position.y >= document.body.clientHeight / 2.4 ? 'auto' : this.state.position.top + this.select.offsetHeight + height,
              bottom: this.state.position && this.state.position.y >= document.body.clientHeight / 2.4 ? document.body.clientHeight - this.state.position.bottom + this.select.offsetHeight + height : 'auto',
              left: this.state.position.x
            },
            onMouseLeave: function () {
              function onMouseLeave() {
                _this5.isCursor = true;
              }

              return onMouseLeave;
            }(),
            onMouseEnter: function () {
              function onMouseEnter() {
                _this5.isCursor = false;
              }

              return onMouseEnter;
            }(),
            className: (0, _classnames2['default'])(String(className) + '__modal', (_classNames7 = {}, _defineProperty(_classNames7, String(className) + '__modal__empty', !isEmpty && optionsKeysFiltered.length === 0), _defineProperty(_classNames7, String(className) + '__modal__top', this.state.position && this.state.position.y >= document.body.clientHeight / 2.4), _classNames7))
          }),
          isEmpty && optionsKeysFiltered.length === 0 && _react2['default'].createElement(
            'div',
            { className: String(className) + '__option__empty' },
            emptyFilterText
          ),
          _react2['default'].createElement(
            _reactPerfectScrollbar2['default'],
            {
              onScrollY: this.handleScroll,
              option: {
                wheelPropagation: false
              },
              containerRef: function () {
                function containerRef(node) {
                  _this5.scrollModal = node || _this5.scrollModal;
                  if (_this5.scrollModal && optimizeHeightPanel && _this5.scrollModal.clientHeight && _this5.state.modalHeight !== _this5.scrollModal.clientHeight) {
                    _this5.setState({ modalHeight: _this5.scrollModal.clientHeight });
                  }
                }

                return containerRef;
              }(),
              className: String(className) + '__modal__scrollbar scrollbar__dark'
            },
            theFirstEmptyElement && optionId && _react2['default'].createElement(
              'button',
              {
                className: String(className) + '__option',
                onClick: function () {
                  function onClick() {
                    typeof _onClick === 'function' && _onClick('');
                    _this5.setState({
                      isModal: false,
                      isInput: false,
                      search: '',
                      scroll: 0,
                      modalHeight: defaultModalHeight
                    });
                  }

                  return onClick;
                }()
              },
              '\u041E\u0447\u0438\u0441\u0442\u0438\u0442\u044C'
            ),
            optionsKeysFiltered.length > 0 && !!noVisibleBeforeHeight && _react2['default'].createElement('div', { style: { minHeight: noVisibleBeforeHeight } }),
            optionsKeysFiltered.slice(noVisibleBeforeCountElements, noVisibleBeforeCountElements + visibleCountElements).map(function (optionKey, index) {
              return _react2['default'].createElement(
                'button',
                {
                  key: index,
                  className: (0, _classnames2['default'])(String(className) + '__option', _defineProperty({}, String(className) + '__option__selected', optionId + '' === (fieldId && options[optionKey][fieldId] || options[optionKey]) + '' || options[optionKey][fieldName] === optionId)),
                  onClick: function () {
                    function onClick() {
                      typeof _onClick === 'function' && _onClick(options[optionKey]);
                      _this5.setState({
                        isModal: false,
                        isInput: false,
                        search: '',
                        scroll: 0,
                        modalHeight: defaultModalHeight
                      });
                    }

                    return onClick;
                  }()
                },
                fieldColor && (0, _onlinepbxStatus2['default'])({
                  status: {
                    isEllipse: true,
                    text: true,
                    name: options[optionKey][fieldColor]
                  }
                }),
                _react2['default'].createElement(
                  'div',
                  { className: String(className) + '__option__text' },
                  nameResolver(fieldName, fieldId, options, optionKey)
                )
              );
            }),
            optionsKeysFiltered.length > 0 && !!noVisibleAfterHeight && _react2['default'].createElement('div', { style: { minHeight: noVisibleAfterHeight } })
          )
        );
      }

      return renderModal;
    }()
  }]);

  return OnlinepbxSelect;
}(_react2['default'].Component), _class.defaultProps = {
  isDisabledSearch: false
}, _temp);
exports['default'] = OnlinepbxSelect;